import React from 'react';
import { useRoutes } from 'react-router-dom';
import { Azure } from 'src/azure-component';
import {
  mainRoutes,
  glmsPlayerGamesRoutes,
  glmsPlayerCoursesRoutes,
  glmsProfileRoutes,
  gamesWorkflowRoutes,
  analyticsRoutes
} from 'src/routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'src/assets/styles/main.scss';
import 'src/App.css';
import { AuthProvider } from "./contexts";
// ========================================================================== //
// ================================= LOGIC ================================== //
// ========================================================================== //

function App() {
  const GLMSApp = () => {
    return useRoutes([
      mainRoutes,
      glmsPlayerCoursesRoutes,
      glmsPlayerGamesRoutes,
      glmsProfileRoutes,
      gamesWorkflowRoutes,
      analyticsRoutes
    ]);
  }
  return (
      <Azure forceLogin={true}>
        <AuthProvider>
          <GLMSApp />
        </AuthProvider>
      </Azure>
  );
}

export default App;
